import { mdiBullhorn } from "@mdi/js";

const marketingNav = [
  {
    title: "Marketing",
    icon: mdiBullhorn,
    children: [
      {
        title: "Infos Marques",
        to: {
          name: "marketing-infos-marques",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "Data Import",
        to: {
          name: "marketing-data-import",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "Data Matching",
        to: {
          name: "marketing-data-matching",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "View Imported Data",
        to: {
          name: "marketing-view-imported-data",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "Configuration des sources",
        to: {
          name: "marketing-source-settings",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "Génération de présentations",
        to: {
          name: "marketing-generate-presentations",
        },
        resource: "marketing",
        action: "manage",
      },
      {
        title: "Debug",
        to: {
          name: "marketing-debug",
        },
        resource: "marketing",
        action: "manage",
      },
    ],
  },
];

export default marketingNav;
